export const GET_PROFILES = "GET_PROFILES";
export const GET_PROFILE_BY_ID = "GET_PROFILE_BY_ID";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const DELETE_PROFILE = "DELETE_PROFILE";
export const CREATE_PROFILE = "CREATE_PROFILE";
